'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Calendar = require('./Calendar.scss');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _reactRedux = require('react-redux');

var _calendar = require('redux/modules/calendar');

var calendarAction = _interopRequireWildcard(_calendar);

var _calendar2 = require('utils/calendar');

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Calendar: {
    displayName: 'Calendar'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/Calendar/Calendar.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

_moment2.default.tz.setDefault('Asia/Bangkok');

var Calendar = _wrapComponent('Calendar')((_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  if (ownProps.tripAvailability) {
    return {
      calendar: state.calendar.tripAvailability.data,
      selectedDay: state.calendar.selected.day,
      loaded: state.calendar.tripAvailability.loaded,
      loading: state.calendar.tripAvailability.loading,
      error: state.calendar.selected.error,
      locale: state.language.locale,
      hideLightning: state.info.userConfig.hideLightning
    };
  } else if (ownProps.free) {
    return {
      calendar: state.calendar.plain.calendar,
      selectedDay: state.calendar.selected.day,
      loaded: state.calendar.plain.loaded,
      locale: state.language.locale
    };
  } else if (ownProps.range) {
    return {
      calendar: state.calendar.plain.calendar,
      step: state.calendar.selected.step,
      selectedRange: state.calendar.selected.range,
      loaded: state.calendar.plain.loaded,
      locale: state.language.locale
    };
  } else if (ownProps.userAvailability) {
    if (ownProps.twin) {
      if (!state.calendar.userAvailability.loaded) {
        return { loaded: false };
      }
      if (ownProps.left) {
        return {
          calendar: state.calendar.userAvailability.data[0],
          loaded: state.calendar.userAvailability.loaded,
          loading: state.calendar.userAvailability.loading,
          mode: state.availability.mode,
          locale: state.language.locale
        };
      }
      if (ownProps.right) {
        return {
          calendar: state.calendar.userAvailability.data[1],
          loaded: state.calendar.userAvailability.loaded,
          loading: state.calendar.userAvailability.loading,
          mode: state.availability.mode,
          locale: state.language.locale
        };
      }
    } else {
      if (!state.calendar.userAvailability.loaded) {
        return { loaded: false };
      }
      return {
        calendar: state.calendar.userAvailability.data[0],
        loaded: state.calendar.userAvailability.loaded,
        loading: state.calendar.userAvailability.loading,
        mode: state.availability.mode,
        locale: state.language.locale
      };
    }
  } else if (ownProps.selectableDays) {
    if (ownProps.multiple) {
      return {
        calendar: state.calendar.limited.calendar,
        selectedDays: state.calendar.selected.days,
        loaded: state.calendar.limited.loaded,
        locale: state.language.locale
      };
    }
    return {
      calendar: state.calendar.limited.calendar,
      selectedDay: state.calendar.selected.day,
      loaded: state.calendar.limited.loaded,
      locale: state.language.locale
    };
  }
  return {};
}, calendarAction), _dec2 = (0, _reactCssModules2.default)(_Calendar2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Calendar, _Component);

  function Calendar(props) {
    (0, _classCallCheck3.default)(this, Calendar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call(this, props));

    _this.componentDidMount = function () {
      if (_this.props.tripAvailability) {
        if (_this.props.initialDate) {
          // deprecated ?
          _this.props.loadTripAvailability(_this.props.trip, (0, _moment2.default)(_this.props.initialDate).format('MMMM YYYY'), _this.getTicketIds()).then(function (res) {
            var days = res.days;
            // console.log('days', days);
            // console.log('init', this.props.initialDate);

            var selectedDate = _lodash2.default.find(days, { date: (0, _moment2.default)(_this.props.initialDate).toDate() });
            // console.log('selected', selectedDate);
            // if (selectedDate && selectedDate.status !== 'n/a') {
            if (selectedDate && (selectedDate.status !== 'n/a' || _this.props.allowBookOnNA)) {
              _this.props.selectDay(_this.props.initialDate, selectedDate.status === 'available' ? true : false);
            } else {
              _this.props.selectDay(null, false);
            }
          });
        } else if (_this.props.offsetDay) {
          _this.props.loadTripAvailability(_this.props.trip, (0, _moment2.default)().add(_this.props.offsetDay, 'day').format('MMMM YYYY'), _this.getTicketIds());
        } else {
          _this.props.loadTripAvailability(_this.props.trip, null, _this.getTicketIds());
        }
      } else if (_this.props.userAvailability) {
        _this.props.loadUserAvailability();
      } else if (_this.props.range || _this.props.free) {
        var month = void 0;
        if (_this.props.initialDate) {
          month = (0, _moment2.default)(_this.props.initialDate).format('MMMM YYYY');
          _this.props.selectDay(_this.props.initialDate);
        }
        _this.props.loadPlainCalendar(month);
      } else if (_this.props.selectableDays) {
        _this.props.loadLimitedCalendar(null, _this.props.selectableDays);
      }
    };

    _this.onPrev = function () {
      var prevMonth = _this.props.calendar.prev;
      if (_this.props.tripAvailability) {
        _this.props.loadTripAvailability(_this.props.trip, prevMonth, _this.getTicketIds());
      } else if (_this.props.range || _this.props.free) {
        _this.props.loadPlainCalendar(prevMonth);
      } else if (_this.props.userAvailability) {
        if (_this.props.twin) {
          _this.props.loadUserAvailability((0, _calendar2.getPrevMonth)(prevMonth));
        } else {
          _this.props.loadUserAvailability(prevMonth);
        }
        _this.props.onPrev();
      } else if (_this.props.selectableDays) {
        _this.props.loadLimitedCalendar(prevMonth, _this.props.selectableDays);
      }
    };

    _this.onNext = function () {
      var nextMonth = _this.props.calendar.next;
      if (_this.props.tripAvailability) {
        _this.props.loadTripAvailability(_this.props.trip, nextMonth, _this.getTicketIds());
      } else if (_this.props.range || _this.props.free) {
        _this.props.loadPlainCalendar(nextMonth);
      } else if (_this.props.userAvailability) {
        _this.props.loadUserAvailability(nextMonth);
        _this.props.onNext();
      } else if (_this.props.selectableDays) {
        _this.props.loadLimitedCalendar(nextMonth, _this.props.selectableDays);
      }
    };

    _this.getTicketIds = function () {
      var _this$props = _this.props,
          trip = _this$props.trip,
          activeTier = _this$props.activeTier;

      var selectedTier = trip.multi_tier_prices.find(function (tier) {
        return tier.tier === activeTier;
      });
      if (!selectedTier) {
        return [];
      }
      var ticketIds = selectedTier.sub_tiers.filter(function (subTier) {
        return subTier.has_availability;
      }).map(function (subTier) {
        return subTier.globaltix_ticket_id;
      });
      return ticketIds;
    };

    return _this;
  }

  (0, _createClass3.default)(Calendar, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var _this2 = this;

      if (nextProps.tripAvailability) {
        if (this.props.trip._id !== nextProps.trip._id) {
          if (nextProps.initialDate) {
            this.props.loadTripAvailability(nextProps.trip, (0, _moment2.default)(nextProps.initialDate).format('MMMM YYYY')).then(function (res) {
              var days = res.days;

              var selectedDate = _lodash2.default.find(days, { date: (0, _moment2.default)(nextProps.initialDate).toDate() });
              if (selectedDate && selectedDate.status !== 'n/a') {
                _this2.props.selectDay(nextProps.initialDate, selectedDate.status === 'available' ? true : false);
              } else {
                _this2.props.selectDay(null, false);
              }
            });
          } else if (nextProps.offsetDay) {
            this.props.loadTripAvailability(nextProps.trip, (0, _moment2.default)().add(nextProps.offsetDay, 'day').format('MMMM YYYY'));
          } else {
            this.props.loadTripAvailability(nextProps.trip);
          }
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.setDay(null);
    }
  }, {
    key: 'onClick',
    value: function onClick(day) {
      if (!day || !day.status) return;
      if (day.booking_id && this.props.userAvailability) return;
      if (day.status === 'n/a' && !this.props.userAvailability && !this.props.allowBookOnNA) return;
      if (this.props.tripAvailability) {
        var instant = false;
        if (day.status === 'available') {
          instant = true;
        }
        this.props.selectDay(day.date, instant);
        this.props.onChange(day.date, day.status);
      }
      if (this.props.range) {
        this.props.selectRange(day.date);
        if (this.props.step) {
          this.props.onSelectRange([this.props.selectedRange[0], day.date]);
          this.props.onChange([this.props.selectedRange[0], day.date]);
        }
      }
      if (this.props.free) {
        this.props.selectDay(day.date);
        this.props.onChange(day.date);
      }
      if (this.props.userAvailability) {
        this.props.setAvailabilityDay(day.date, this.props.mode);
        this.props.onChange(day.date, this.props.mode);
      }
      if (this.props.selectableDays && this.props.multiple) {
        this.props.selectDayMultiple(day.date);
        this.props.onChange(day.date);
      }
      if (this.props.selectableDays && !this.props.multiple) {
        this.props.selectDay(day.date);
        this.props.onChange(day.date);
      }
    }
  }, {
    key: 'onClickWeekDay',
    value: function onClickWeekDay(index) {
      this.props.onClickWeekDay(index);
    }
  }, {
    key: 'getWDStyle',
    value: function getWDStyle(mode) {
      if (mode === 'n/a') return 'na';
      if (mode === 'default') return 'ask';
      return mode;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          trip = _props.trip,
          loading = _props.loading,
          loaded = _props.loaded,
          error = _props.error,
          locale = _props.locale,
          availableDays = _props.availableDays,
          _props$hoursInAdvance = _props.hoursInAdvance,
          hoursInAdvance = _props$hoursInAdvance === undefined ? 0 : _props$hoursInAdvance,
          hideLightning = _props.hideLightning,
          noWeekDayAction = _props.noWeekDayAction;

      if (!loaded) {
        return _react3.default.createElement(
          'div',
          { styleName: 'calendar-loader' },
          _react3.default.createElement(_Loader2.default, null)
        );
      }
      var _props$calendar = this.props.calendar,
          current = _props$calendar.current,
          days = _props$calendar.days;

      var hasInstantDate = days.some(function (d) {
        return d && d.status === 'available';
      });
      var datePlusHourInAdvance = (0, _moment2.default)().add(hoursInAdvance, 'hour').startOf('day');
      return _react3.default.createElement(
        'div',
        { styleName: 'calendar-wrapper' },
        _react3.default.createElement(
          'div',
          { 'data-tmt': 'calendar', styleName: error ? 'calendar-error' : 'calendar' },
          _react3.default.createElement(
            'div',
            { styleName: 'months' },
            _react3.default.createElement('div', { 'data-tmt': 'calendar-prev', styleName: !this.props.right ? 'prev' : 'prev-hidden', onClick: this.onPrev }),
            _react3.default.createElement(
              'span',
              { 'data-tmt': 'calendar-month' },
              (0, _moment2.default)(current, 'MMMM YYYYY').format((0, _calendar2.getMYFormat)(locale))
            ),
            _react3.default.createElement('div', { 'data-tmt': 'calendar-next', styleName: !this.props.left ? 'next' : 'next-hidden', onClick: this.onNext })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'week-label' },
            _moment2.default.weekdaysMin().map(function (wd, index) {
              return _react3.default.createElement(
                'div',
                {
                  key: index,
                  styleName: '' + (availableDays ? 'day-label-' + _this3.getWDStyle(availableDays[index]) : 'day-label') + (noWeekDayAction ? ' day-no-hover' : ''),
                  onClick: _this3.props.userAvailability ? _this3.onClickWeekDay.bind(_this3, index) : function () {} },
                wd
              );
            })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'days' },
            days.map(function (day, index) {
              var styleName = void 0;
              var thisDay = (0, _moment2.default)(day.date);
              var canClick = true;
              if (thisDay.isBefore(datePlusHourInAdvance, 'day') && trip && trip.product_type === 'souvenir') {
                styleName = 'day-cell-gray';
                canClick = false;
              } else if (_this3.props.selectedDay && day.date && thisDay.isSame(_this3.props.selectedDay, 'day') && !_this3.props.selectableDays) {
                if (day.status === 'available') {
                  styleName = hideLightning ? 'day-cell-selected' : 'day-cell-instant-selected';
                } else if (day.status === 'n/a') {
                  styleName = 'day-cell-yellow';
                } else {
                  styleName = 'day-cell-selected';
                }
              } else if (_this3.props.selectedDay && thisDay.isSame(_this3.props.selectedDay, 'day') && _this3.props.selectableDays) {
                styleName = 'day-cell-green';
              } else if (_this3.props.selectableDays && _this3.props.multiple && (0, _calendar2.findDate)(_this3.props.selectedDays, day.date) >= 0) {
                styleName = 'day-cell-green';
              } else if (_this3.props.selectableDays && day.status === 'selectable') {
                styleName = 'day-cell-green-border';
              } else if (_this3.props.selectableDays && day.status !== 'selectable') {
                styleName = 'day-cell-gray';
                canClick = false;
              } else if (_this3.props.selectedRange && !thisDay.isBefore(_this3.props.selectedRange[0], 'day') && !thisDay.isAfter(_this3.props.selectedRange[1], 'day')) {
                styleName = 'day-cell-selected';
              } else if (day.booking_id && _this3.props.userAvailability || day.passed) {
                styleName = 'day-cell-gray';
                canClick = false;
              } else if (day.status === 'n/a' && _this3.props.userAvailability) {
                styleName = 'day-cell-red';
              } else if (_this3.props.range && _this3.props.step === 1 && thisDay.isBefore(_this3.props.selectedRange[0], 'day')) {
                styleName = 'day-cell-gray';
                canClick = false;
              } else if (day.status === 'available') {
                styleName = hideLightning ? 'day-cell-normal' : 'day-cell-instant';
              } else if (_this3.props.userAvailability && day.status && !day.passed && availableDays[thisDay.day()] === 'n/a') {
                styleName = 'day-cell-red';
              } else if (_this3.props.userAvailability && day.status && !day.passed && availableDays[thisDay.day()] === 'available') {
                styleName = 'day-cell-instant';
              } else if (day.status === 'ask') {
                styleName = 'day-cell-normal';
              } else if (_this3.props.tripAvailability && _this3.props.allowBookOnNA && day.date && !day.tripNotOperate && !day.tripEndDay) {
                styleName = 'day-cell-gray-alternate';
              } else {
                styleName = 'day-cell-gray';
                canClick = false;
              }
              if (_this3.props.userAvailability && styleName !== 'day-cell-gray') {
                styleName = 'user-' + styleName;
              }
              var children = ['day-cell-green-border', 'day-cell-normal', 'day-cell-instant', 'day-cell-gray-alternate'].indexOf(styleName) >= 0 ? _react3.default.createElement(
                'div',
                { styleName: 'green-border-inner' },
                day.day
              ) : day.day;
              return _react3.default.createElement(
                'div',
                { key: day.date || 'date-' + index, 'data-tmt': styleName, onClick: canClick ? _this3.onClick.bind(_this3, day) : null, styleName: styleName },
                children
              );
            })
          ),
          loading && _react3.default.createElement(
            'div',
            { styleName: 'loader-container' },
            _react3.default.createElement(_Loader2.default, null)
          )
        ),
        this.props.tripAvailability && hasInstantDate && !hideLightning && _react3.default.createElement(
          'div',
          { styleName: 'instant-container' },
          _react3.default.createElement('span', { styleName: 'instant-icon' }),
          ' = Instant Confirmation'
        )
      );
    }
  }]);
  return Calendar;
}(_react2.Component), _class2.propTypes = {
  type: _react2.PropTypes.string,
  trip: _react2.PropTypes.object,
  hideLightning: _react2.PropTypes.bool,
  tripAvailability: _react2.PropTypes.bool,
  userAvailability: _react2.PropTypes.bool,
  twin: _react2.PropTypes.bool,
  left: _react2.PropTypes.bool,
  right: _react2.PropTypes.bool,
  range: _react2.PropTypes.bool,
  free: _react2.PropTypes.bool,
  allowBookOnNA: _react2.PropTypes.bool,
  multiple: _react2.PropTypes.bool,
  selectableDays: _react2.PropTypes.array,
  availableDays: _react2.PropTypes.array,
  loadTripAvailability: _react2.PropTypes.func,
  loadUserAvailability: _react2.PropTypes.func,
  loadPlainCalendar: _react2.PropTypes.func,
  loadLimitedCalendar: _react2.PropTypes.func,
  calendar: _react2.PropTypes.object,
  selectedDay: _react2.PropTypes.any,
  selectedDays: _react2.PropTypes.array,
  selectedRange: _react2.PropTypes.array,
  selectDay: _react2.PropTypes.func,
  selectDayMultiple: _react2.PropTypes.func,
  selectRange: _react2.PropTypes.func,
  onSelectRange: _react2.PropTypes.func,
  toggleDay: _react2.PropTypes.func,
  setAvailabilityDay: _react2.PropTypes.func,
  loaded: _react2.PropTypes.bool,
  loading: _react2.PropTypes.bool,
  step: _react2.PropTypes.number,
  mode: _react2.PropTypes.string,
  onChange: _react2.PropTypes.func,
  onClickWeekDay: _react2.PropTypes.func,
  onNext: _react2.PropTypes.func,
  onPrev: _react2.PropTypes.func,
  initialDate: _react2.PropTypes.any,
  error: _react2.PropTypes.bool,
  locale: _react2.PropTypes.string,
  offsetDay: _react2.PropTypes.number,
  setDay: _react2.PropTypes.func,
  hoursInAdvance: _react2.PropTypes.number,
  activeTier: _react2.PropTypes.string,
  noWeekDayAction: _react2.PropTypes.bool
}, _class2.defaultProps = {
  onChange: function onChange() {},
  onClickWeekDay: function onClickWeekDay() {}
}, _temp)) || _class) || _class));

exports.default = Calendar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Calendar/Calendar.js
// module id = 89
// module chunks = 47